import { snakeCase } from "es-toolkit";

type KebabToSnakeCase<S extends string> = S extends `${infer T}-${infer U}`
  ? `${T}_${KebabToSnakeCase<U>}`
  : S;

type SnakeCaseToKebab<S extends string> = S extends `${infer T}_${infer U}`
  ? `${T}-${KebabToSnakeCase<U>}`
  : S;

type KebabToScreamingSnakeCase<S extends string> = Uppercase<KebabToSnakeCase<S>>;

type ScreamingSnakeCaseToKebab<S extends string> = Lowercase<SnakeCaseToKebab<S>>;

/**
 * creates map of record keys
 * @returns key map in the form: { RECORD_KEY: "record-key" }
 */
export function createKeyMap<K extends string, V>(obj: Record<K, V>) {
  return Object.keys(obj).reduce(
    (acc, key) => {
      const k = snakeCase(key).toUpperCase() as KebabToScreamingSnakeCase<typeof key>;
      acc[k] = key;
      return acc;
    },
    {} as Record<string, string>,
  ) as { [Key in KebabToScreamingSnakeCase<K>]: ScreamingSnakeCaseToKebab<Key> };
}
